import { readingFeatures } from '@/mocks/comics';

export default function Features() {
  return (
    <section id="features" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
          <i className="ri-flashlight-line" />
          阅读体验
        </span>
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">为手机阅读而生的体验</h2>
        <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
          无论是网页版还是客户端，咪咕漫画网都围绕移动端场景精心打磨每一处细节。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
        {readingFeatures.map((f, i) => (
          <article
            key={f.title}
            className="group flex gap-4 rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-primary-200"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
              <i className={f.icon} />
            </span>
            <div>
              <h3 className="text-base font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
            <span className="ml-auto self-start font-heading text-lg text-background-300">0{i + 1}</span>
          </article>
        ))}
      </div>
    </section>
  );
}